var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersCount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip0_14065_55561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1536 13.1445V11.9779C10.1536 11.359 9.90781 10.7655 9.47023 10.3279C9.03264 9.89036 8.43915 9.64453 7.82031 9.64453H3.15365C2.53481 9.64453 1.94131 9.89036 1.50373 10.3279C1.06615 10.7655 0.820313 11.359 0.820312 11.9779V13.1445",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4974 7.3112C6.78606 7.3112 7.83073 6.26653 7.83073 4.97786C7.83073 3.6892 6.78606 2.64453 5.4974 2.64453C4.20873 2.64453 3.16406 3.6892 3.16406 4.97786C3.16406 6.26653 4.20873 7.3112 5.4974 7.3112Z",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 13.1468V11.9802C13.6637 11.4632 13.4916 10.9609 13.1749 10.5523C12.8581 10.1437 12.4146 9.8519 11.9141 9.72266",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57031 2.72266C10.0722 2.85117 10.5171 3.14307 10.8348 3.55234C11.1525 3.96161 11.3249 4.46497 11.3249 4.98307C11.3249 5.50117 11.1525 6.00454 10.8348 6.41381C10.5171 6.82308 10.0722 7.11498 9.57031 7.24349",
    stroke: "#0129FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14065_55561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.242188 0.894531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCount);
export default __webpack_public_path__ + "static/media/usersCount.635ac8eb1b928bdc48e3c4d6e6779baa.svg";
export { ForwardRef as ReactComponent };